(function () {
  var root = document.querySelector(".los-filters");
  var grid = document.querySelector("[data-los-grid]");
  if (!root || !grid) return;

  var handle = root.getAttribute("data-los-collection");
  var originals = Array.prototype.slice.call(grid.querySelectorAll(".los-card"));
  var selected = { brand: [], type: [], cartridge: [], color: [], connect: [], form: [], price: [], sale: [] };
  var products = [];
  var openGroup = "";

  var PRICE = [
    { id: "under-25", label: "Under $25", test: function (c) { return c < 2500; } },
    { id: "25-50", label: "$25 to $50", test: function (c) { return c >= 2500 && c < 5000; } },
    { id: "50-100", label: "$50 to $100", test: function (c) { return c >= 5000 && c < 10000; } },
    { id: "100-250", label: "$100 to $250", test: function (c) { return c >= 10000 && c < 25000; } },
    { id: "250-up", label: "$250 and Up", test: function (c) { return c >= 25000; } }
  ];

  var COLORS = [
    ["Red / Black", /\bred\s*\/\s*black\b/i],
    ["Tri-Color", /\btri-?colou?r\b/i],
    ["Cyan", /\bcyan\b/i],
    ["Magenta", /\bmagenta\b/i],
    ["Yellow", /\byellow\b/i],
    ["Black", /\bblack\b/i],
    ["Gray", /\bgr[ae]y\b/i],
    ["Blue", /\bblue\b/i],
    ["Red", /\bred\b/i],
    ["White", /\bwhite\b/i],
    ["Green", /\bgreen\b/i]
  ];

  var CONNECTS = [
    ["USB-C", /\busb-?c\b|\btype-?c\b/i],
    ["HDMI", /\bhdmi\b/i],
    ["DisplayPort", /\bdisplayport\b|\bdisplay\s*port\b/i],
    ["Ethernet", /\bcat\.?\s*[56]\b|\bethernet\b/i],
    ["VGA", /\bvga\b/i],
    ["DVI", /\bdvi\b/i],
    ["Thunderbolt", /\bthunderbolt\b/i],
    ["Audio", /\baudio\b|\b3\.5\s?mm\b/i],
    ["USB", /\busb\b/i]
  ];

  function esc(s) {
    return String(s).replace(/[&<>"']/g, function (c) {
      return { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" }[c];
    });
  }

  function money(n) {
    return "$" + n.toLocaleString("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  }

  function readParams() {
    var params = new URLSearchParams(window.location.search);
    Object.keys(selected).forEach(function (key) {
      selected[key] = key === "sale" ? (params.get("sale") === "1" ? ["1"] : []) : params.getAll(key);
    });
  }

  function writeParams() {
    var params = new URLSearchParams(window.location.search);
    Object.keys(selected).forEach(function (key) { params.delete(key); });
    Object.keys(selected).forEach(function (key) {
      selected[key].forEach(function (value) { params.append(key, value); });
    });
    var qs = params.toString();
    history.replaceState(null, "", window.location.pathname + (qs ? "?" + qs : ""));
  }

  function active() {
    return Object.keys(selected).some(function (key) { return selected[key].length > 0; });
  }

  function centsOf(p) {
    return Math.round(p.price * 100);
  }

  function colorOf(title) {
    for (var i = 0; i < COLORS.length; i++) {
      if (COLORS[i][1].test(title)) return COLORS[i][0];
    }
    return "";
  }

  function connectsOf(title) {
    var hits = [];
    CONNECTS.forEach(function (rule) {
      if (rule[1].test(title)) hits.push(rule[0]);
    });
    if (hits.indexOf("USB-C") !== -1) hits = hits.filter(function (h) { return h !== "USB"; });
    return hits;
  }

  function cartridgeOf(title) {
    if (/\bribbon\b|\bink roll\b/i.test(title)) return "Ribbon";
    if (/\btoner\b/i.test(title)) return "Toner";
    if (/\bink\b/i.test(title)) return "Ink";
    return "";
  }

  function formsOf(title) {
    var hits = [];
    if (/wall\s*mount/i.test(title)) hits.push("Wall Mount");
    if (/\brack\b/i.test(title)) hits.push("Rack");
    if (/\btower\b/i.test(title)) hits.push("Tower");
    return hits;
  }

  function priceId(cents) {
    for (var i = 0; i < PRICE.length; i++) {
      if (PRICE[i].test(cents)) return PRICE[i].id;
    }
    return "";
  }

  function enrich(raw) {
    var variants = (raw.variants || []).filter(function (v) { return v.available; });
    if (!variants.length) return null;
    variants.sort(function (a, b) { return parseFloat(a.price) - parseFloat(b.price); });
    var variant = variants[0];
    var price = parseFloat(variant.price);
    var compare = parseFloat(variant.compare_at_price || "0");
    var title = raw.title || "";
    return {
      id: String(raw.id),
      title: title,
      handle: raw.handle,
      vendor: raw.vendor || "",
      type: raw.product_type || "",
      image: raw.images && raw.images[0] ? raw.images[0].src : "",
      variantId: variant.id,
      variantCount: variants.length,
      price: price,
      compare: compare > price ? compare : 0,
      sale: compare > price,
      cartridge: cartridgeOf(title),
      color: colorOf(title),
      connect: connectsOf(title),
      form: formsOf(title),
      priceId: priceId(Math.round(price * 100))
    };
  }

  function matchesGroup(product, key) {
    var picks = selected[key];
    if (!picks.length) return true;
    if (key === "sale") return product.sale;
    if (key === "brand") return picks.indexOf(product.vendor) !== -1;
    if (key === "type") return picks.indexOf(product.type) !== -1;
    if (key === "cartridge") return picks.indexOf(product.cartridge) !== -1;
    if (key === "color") return picks.indexOf(product.color) !== -1;
    if (key === "price") return picks.indexOf(product.priceId) !== -1;
    if (key === "connect") return product.connect.some(function (v) { return picks.indexOf(v) !== -1; });
    if (key === "form") return product.form.some(function (v) { return picks.indexOf(v) !== -1; });
    return true;
  }

  function matches(product, except) {
    return Object.keys(selected).every(function (key) {
      if (key === except) return true;
      return matchesGroup(product, key);
    });
  }

  function groups() {
    var list = [];

    function addList(key, label, values, minProducts) {
      var counts = {};
      products.forEach(function (p) {
        var vals = values(p);
        if (!vals) return;
        (Array.isArray(vals) ? vals : [vals]).forEach(function (v) {
          if (!v) return;
          counts[v] = (counts[v] || 0) + 1;
        });
      });
      var options = Object.keys(counts);
      var covered = options.reduce(function (sum, id) { return sum + counts[id]; }, 0);
      if (options.length < 2 || covered < (minProducts || 2)) return;
      options.sort(function (a, b) { return counts[b] - counts[a] || a.localeCompare(b); });
      list.push({
        key: key,
        label: label,
        options: options.map(function (id) { return { id: id, label: id, count: counts[id] }; })
      });
    }

    addList("brand", "Brand", function (p) { return p.vendor; });
    addList("type", "Type", function (p) { return p.type; });
    addList("cartridge", "Cartridge", function (p) { return p.cartridge; });
    addList("connect", "Connection", function (p) { return p.connect; }, 3);
    addList("color", "Color", function (p) { return p.color; }, 3);
    addList("form", "Form", function (p) { return p.form; }, 3);

    var priceOptions = PRICE.map(function (bucket) {
      return {
        id: bucket.id,
        label: bucket.label,
        count: products.filter(function (p) { return p.priceId === bucket.id; }).length
      };
    }).filter(function (o) { return o.count > 0; });
    if (priceOptions.length > 1) list.push({ key: "price", label: "Price", options: priceOptions });

    var saleCount = products.filter(function (p) { return p.sale; }).length;
    if (saleCount > 0 && saleCount < products.length) {
      list.push({ key: "sale", label: "On Sale", toggle: true, options: [{ id: "1", label: "On Sale", count: saleCount }] });
    }
    return list;
  }

  function facetCount(group, optionId) {
    return products.filter(function (p) {
      if (!matches(p, group.key)) return false;
      if (group.key === "sale") return p.sale;
      if (group.key === "brand") return p.vendor === optionId;
      if (group.key === "type") return p.type === optionId;
      if (group.key === "cartridge") return p.cartridge === optionId;
      if (group.key === "color") return p.color === optionId;
      if (group.key === "price") return p.priceId === optionId;
      if (group.key === "connect") return p.connect.indexOf(optionId) !== -1;
      if (group.key === "form") return p.form.indexOf(optionId) !== -1;
      return false;
    }).length;
  }

  function cardHtml(p) {
    var img = p.image ? '<img src="' + esc(p.image) + (p.image.indexOf("?") === -1 ? "?width=480" : "&width=480") + '" alt="' + esc(p.title) + '">' : "";
    var flag = p.sale ? '<span class="los-flag">Sale</span>' : "";
    var was = p.compare ? '<span class="los-was">' + money(p.compare) + "</span>" : "";
    var buy = p.variantCount > 1
      ? '<a class="los-add" href="/products/' + esc(p.handle) + '">Choose Options</a>'
      : '<form action="/cart/add" method="post" class="variants los-buy" enctype="multipart/form-data"><input type="hidden" name="id" value="' + esc(p.variantId) + '"><button class="btn add-to-cart-btn los-add" type="submit">Add to cart</button></form>';
    return '<article class="los-card' + (p.sale ? " is-sale" : "") + '" id="product-' + esc(p.id) + '" data-los-extra="1">' +
      '<a class="los-card-media" href="/products/' + esc(p.handle) + '">' + img + flag + "</a>" +
      '<div class="los-card-body"><p class="los-vendor">' + esc(p.vendor) + "</p>" +
      '<a class="los-card-title" href="/products/' + esc(p.handle) + '">' + esc(p.title) + "</a>" +
      '<div class="los-price"><span class="los-now">' + money(p.price) + "</span>" + was + "</div>" +
      buy + "</div></article>";
  }

  function apply() {
    var filtering = active();
    document.body.classList.toggle("los-filtered", filtering);
    var empty = grid.querySelector(".los-filter-empty");
    if (empty) empty.remove();
    grid.querySelectorAll("[data-los-extra]").forEach(function (n) { n.remove(); });

    if (!filtering) {
      originals.forEach(function (node) {
        node.hidden = false;
        grid.appendChild(node);
      });
      var meta = root.querySelector(".los-filter-meta");
      if (meta) meta.textContent = "";
      return;
    }

    var shown = products.filter(function (p) { return matches(p); });
    var byId = {};
    originals.forEach(function (node) { byId[node.id.replace("product-", "")] = node; });
    originals.forEach(function (node) { node.hidden = true; });

    shown.forEach(function (p) {
      var node = byId[p.id];
      if (!node) {
        var wrap = document.createElement("div");
        wrap.innerHTML = cardHtml(p);
        node = wrap.firstChild;
      }
      node.hidden = false;
      grid.appendChild(node);
    });

    var metaOn = root.querySelector(".los-filter-meta");
    if (metaOn) metaOn.textContent = shown.length + " of " + products.length;
    if (!shown.length) {
      var note = document.createElement("p");
      note.className = "los-empty los-filter-empty";
      note.textContent = "Nothing matches these filters.";
      grid.appendChild(note);
    }
  }

  function render() {
    var defs = groups();
    var html = "";
    defs.forEach(function (group) {
      if (group.toggle) {
        var on = selected.sale.length > 0;
        html += '<button type="button" class="los-filter-btn' + (on ? " is-on" : "") + '" data-toggle="sale">On Sale</button>';
        return;
      }
      var picked = selected[group.key].length;
      html += '<div class="los-filter" data-group="' + group.key + '">';
      html += '<button type="button" class="los-filter-btn' + (picked ? " is-on" : "") + '" aria-expanded="' + (openGroup === group.key ? "true" : "false") + '">' + group.label + (picked ? " " + picked : "") + "</button>";
      html += '<div class="los-filter-panel"' + (openGroup === group.key ? "" : " hidden") + ">";
      group.options.forEach(function (opt) {
        var count = facetCount(group, opt.id);
        var checked = selected[group.key].indexOf(opt.id) !== -1;
        html += '<label class="los-filter-opt' + (count === 0 && !checked ? " is-zero" : "") + '">';
        html += '<input type="checkbox" value="' + esc(opt.id) + '"' + (checked ? " checked" : "") + (count === 0 && !checked ? " disabled" : "") + ">";
        html += "<span>" + esc(opt.label) + "</span><span class=\"los-filter-n\">" + count + "</span></label>";
      });
      html += "</div></div>";
    });
    if (active()) html += '<button type="button" class="los-filter-clear">Clear Filters</button>';
    html += '<p class="los-filter-meta"></p>';
    root.innerHTML = html;

    var open = root.querySelector('.los-filter[data-group="' + openGroup + '"] .los-filter-panel');
    var btn = root.querySelector('.los-filter[data-group="' + openGroup + '"] .los-filter-btn');
    if (open && btn) {
      var rect = btn.getBoundingClientRect();
      if (rect.left + 250 > window.innerWidth - 12) open.classList.add("is-end");
    }
    apply();
  }

  function toggleValue(key, value) {
    var list = selected[key];
    var i = list.indexOf(value);
    if (i === -1) list.push(value);
    else list.splice(i, 1);
  }

  root.addEventListener("click", function (event) {
    event.stopPropagation();
    var toggle = event.target.closest("[data-toggle]");
    if (toggle) {
      selected.sale = selected.sale.length ? [] : ["1"];
      openGroup = "";
      writeParams();
      render();
      return;
    }
    if (event.target.closest(".los-filter-clear")) {
      Object.keys(selected).forEach(function (key) { selected[key] = []; });
      openGroup = "";
      writeParams();
      render();
      return;
    }
    var button = event.target.closest(".los-filter-btn");
    if (button) {
      var group = button.parentElement.getAttribute("data-group");
      openGroup = openGroup === group ? "" : group;
      render();
    }
  });

  root.addEventListener("change", function (event) {
    var input = event.target;
    if (input.type !== "checkbox") return;
    var group = input.closest(".los-filter").getAttribute("data-group");
    toggleValue(group, input.value);
    writeParams();
    render();
  });

  document.addEventListener("click", function (event) {
    if (!root.contains(event.target) && openGroup) {
      openGroup = "";
      render();
    }
  });

  function load(page, acc) {
    var params = new URLSearchParams(window.location.search);
    var sort = params.get("sort_by");
    var url = "/collections/" + encodeURIComponent(handle) + "/products.json?limit=250&page=" + page + (sort ? "&sort_by=" + encodeURIComponent(sort) : "");
    return fetch(url).then(function (res) { return res.json(); }).then(function (data) {
      var batch = data.products || [];
      acc = acc.concat(batch);
      if (batch.length === 250) return load(page + 1, acc);
      return acc;
    });
  }

  readParams();
  load(1, []).then(function (raw) {
    products = raw.map(enrich).filter(Boolean);
    render();
  });
})();
